<template>
    <product-map :data="data"></product-map>
</template>
<script>
import ProductMap from '../../../pluginscomponents/ProductMap'
export default {
  name: 'bannerStyle',
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components: {
    ProductMap
  }
}
</script>
<style lang="scss">
.section-body .el-form-item__content{
  margin-left:100px;
}
</style>



// WEBPACK FOOTER //
// style.vue?104b7954